(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Gallery thumbnails: click to change main image, autoplay every 4s in a loop
    var mainImg = document.querySelector("[data-product-main-image]");
    var thumbs = document.querySelectorAll("[data-thumb]");
    if (mainImg && thumbs.length > 0) {
      var galleryTimer = null;

      function showThumb(index) {
        var target = thumbs[index];
        mainImg.src = target.getAttribute("data-full");
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle("is-active", i === index);
        });
      }

      function restartGalleryAutoplay() {
        clearInterval(galleryTimer);
        if (thumbs.length > 1) {
          var current = 0;
          thumbs.forEach(function (thumb, i) {
            if (thumb.classList.contains("is-active")) current = i;
          });
          galleryTimer = setInterval(function () {
            current = (current + 1) % thumbs.length;
            showThumb(current);
          }, 4000);
        }
      }

      thumbs.forEach(function (btn, index) {
        btn.addEventListener("click", function () {
          showThumb(index);
          restartGalleryAutoplay();
        });
      });

      restartGalleryAutoplay();
    }

    // Quantity stepper: +/- buttons to adjust quantity
    var qtyValueEl = document.querySelector("[data-product-qty-value]");
    var qty = 1;
    if (qtyValueEl) {
      document.querySelectorAll("[data-qty]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var delta = parseInt(btn.getAttribute("data-qty"), 10);
          qty = Math.max(1, qty + delta);
          qtyValueEl.textContent = qty;
        });
      });
    }

    // Add to cart button
    var addBtn = document.querySelector("[data-product-add]");
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        if (window.VieiraCart) {
          var variantId = addBtn.getAttribute("data-variant-id");
          window.VieiraCart.addToCart(variantId, qty);
        }
      });
    }
  });
})();
